import { render, staticRenderFns } from "./filmMain.vue?vue&type=template&id=4dd5546c&scoped=true"
import script from "./filmMain.vue?vue&type=script&lang=js"
export * from "./filmMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd5546c",
  null
  
)

export default component.exports